import { logoFullSrc } from "assets/images";

export const AppLogo = () => {
  return <img className="app-logo" alt="Logo" src={logoFullSrc} />;
};
